import { Info } from "lucide-react";
import { SITE } from "../config/site";

/** Availability disclaimer shown wherever bookings are discussed. */
export default function DisclaimerBand() {
  return (
    <div
      data-testid="booking-disclaimer"
      role="note"
      className="flex items-start gap-3 border border-[#27272A] bg-[#111111] p-4"
    >
      <Info className="mt-0.5 h-5 w-5 shrink-0 text-[#D4AF37]" aria-hidden="true" />
      <p className="text-sm leading-relaxed text-[#A1A1AA]">{SITE.availabilityMessage}</p>
    </div>
  );
}
